<template>
  <div style="display: contents">
    <div
      :style="{ 'grid-row': '1 / span 3', top: 0, height: `${headerHeight}px` }"
      class="grid-item-border-bottom flexed-white-bg-grid-item header"
      :class="headerPositioning"
    >
      <div class="d-flex flex-column align-center pa-2 justify-center full-width">
        <div class="inside-box-title">
          <div class="title-text">
            <h2 :title="name" class="column-title">
              {{ name }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <TileView v-if="selectedView === views.Tile" :products="products" :group-name="name" />
    <ListView
      v-else
      :products="products"
      :group-name="name"
      :positioning="isStickyHeader"
      :previous-heights="headerHeight"
    />
  </div>
</template>

<script>
import { useAssortmentCanvasStore } from '@/stores/assortment-canvas';
import assortmentCanvases from '@enums/assortment-canvases';
import { mapState } from 'pinia';

export default {
  props: {
    name: {
      required: true,
      type: String,
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      views: assortmentCanvases.Views,
      headerHeight: 85, // Same height as sidebar heading (unified columns)
    };
  },
  computed: {
    ...mapState(useAssortmentCanvasStore, ['stickyHeaders', 'selectedView']),
    headerPositioning() {
      // If user has stickyHeaders option enabled then set their position as sticky.
      return this.stickyHeaders ? 'sticky' : 'relative';
    },
    isStickyHeader() {
      return this.stickyHeaders ? 'sticky' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.column-title {
  font-size: 2rem;
}
</style>
